import { Grid, TextField, Typography } from "@mui/material";
import ReadMoreReadLess from "../../app/common/ReadMoreReadLess";
import { AnswersProps } from "../../app/models/Answers";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = yup.object().shape({
  homeNeeds: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
  homeDisablility: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
});

const StatementHomeVisitingReflection: React.FC<AnswersProps> = ({
  answersData,
  onAnswerChange,
}) => {
  const defaultValues = {
    homeNeeds: answersData.find((answer) => answer.systemCodeId === 22)?.answer,
    homeDisablility: answersData.find((answer) => answer.systemCodeId === 23)
      ?.answer,
  };
  const {
    register,
    formState: { errors },
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const renderWeeklyPlanReflectionCompetence = () => {
    return (
      <>
        <li>
          How do you partner with families and assist with learning, activities,
          and experiences?
        </li>
        <li>
          What strategies do you use to increase insight into family needs?
        </li>
        <li>
          What practices do you implement to provide consistency with home
          visits?
        </li>
      </>
    );
  };

  const renderChildAbuseNeglectPolicyReflectionCompetence = () => {
    return (
      <>
        <li>
          How do you partner with families to support learning and development
          of their child with disabilities and/or special needs?
        </li>
        <li>
          How do you support the emotional and physical needs of a parent(s)
          caring for a child with disabilities and/or special needs?
        </li>
        <li>
          What strategies and tools do you use to connect parents to medical,
          mental health and community resources?
        </li>
      </>
    );
  };

  return (
    <Grid container>
      <Grid item xs={12} px={3} pt={3}>
        <Typography variant="body1" fontWeight="bold" paragraph>
          CS I-b- Weekly Plan for Home Visiting Reflection
        </Typography>
      </Grid>
      <Grid item xs={12} pt={3} px={3}>
        <Typography variant="body1" paragraph>
          How does your weekly plan show your commitment to meeting specific
          needs of the family?
        </Typography>
        <ReadMoreReadLess>
          <>{renderWeeklyPlanReflectionCompetence()}</>
        </ReadMoreReadLess>
      </Grid>
      <Grid item xs={12} pt={3} px={3}>
        <TextField
          label="This weekly plan shows my commitment to meeting the specific needs of the family because"
          multiline
          rows={2}
          fullWidth
          {...register("homeNeeds")}
          name="homeNeeds"
          sx={{ bgcolor: "#FFF" }}
          value={
            answersData.find((answer) => answer.systemCodeId === 22)?.answer ||
            ""
          }
          onChange={(e) => {
            const newValue = e.target.value;
            const systemCodeId = 22;

            newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
          }}
          error={!!errors.homeNeeds?.message}
          helperText={errors.homeNeeds?.message}
        />
        <Typography fontSize={13}>
          {defaultValues.homeNeeds?.length}/500
        </Typography>
      </Grid>
      <Grid item xs={12} pt={3} px={3}>
        <Typography variant="body1" paragraph>
          How would you adapt the plan for families of children with
          disabilities?
        </Typography>
        <ReadMoreReadLess>
          <>{renderChildAbuseNeglectPolicyReflectionCompetence()}</>
        </ReadMoreReadLess>
      </Grid>
      <Grid item xs={12} py={3} px={3}>
        <TextField
          label="I would adapt this weekly plan for families of children with disabilities by"
          multiline
          rows={2}
          fullWidth
          {...register("homeDisablility")}
          name="homeDisablility"
          sx={{ bgcolor: "#FFF" }}
          value={
            answersData.find((answer) => answer.systemCodeId === 23)?.answer ||
            ""
          }
          onChange={(e) => {
            const newValue = e.target.value;
            const systemCodeId = 23;

            newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
          }}
          error={!!errors.homeDisablility?.message}
          helperText={errors.homeDisablility?.message}
        />
        <Typography fontSize={13}>
          {defaultValues.homeDisablility?.length}/500
        </Typography>
      </Grid>
    </Grid>
  );
};
export default StatementHomeVisitingReflection;
